import { motion } from 'framer-motion';

const MissionHero = () => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bd70cd999446f51277ad65cfdb4511a6.jpg"
          alt="勝つ経営を実現する"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-red-dark/75 via-red-dark/65 to-red-dark/75"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            私たちの理念
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-12 leading-relaxed">
            赤石会計事務所は、お客様の成長と成功を支える
            <br className="hidden sm:block" />
            信頼できるパートナーであり続けます
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-red text-white px-8 py-4 rounded-full font-medium hover:bg-red/90 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
          >
            <span>無料相談を予約する</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionHero;
